import React from "react";
import {Box, Button, CircularProgress, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon, FileUploadIcon} from "@hugeicons/core-free-icons";
import {FileUploader} from "react-drag-drop-files";
import {toast} from "react-toastify";
import {ProjectFormNew} from "./ProjectFormNew";

export const ProjectCreateFormNew = ({project, setProject, languages, organizations, fetchData, loading}) => {
  return (
    <>
      <ProjectFormNew
        setProject={setProject}
        project={project}
        languages={languages}
        organizations={organizations}
        fetchData={fetchData}
        multipleLanguages
      />

      <Box sx={{px: {xs: 2, md: 3}, pb: {xs: 2, md: 3}}}>
        <Typography sx={{fontSize: 14, fontWeight: 700, color: "#23264D", mb: 0.25}}>
          Start from an existing assistant <Typography component={"span"} sx={{color: "#8A8AA0", fontWeight: 400}}>(optional)</Typography>
        </Typography>
        <Typography sx={{fontSize: 12.5, color: "#8A8AA0", mb: 1.5}}>
          Upload a JSON export to continue working from an existing assistant. Leave this empty to create a new assistant from scratch.
        </Typography>
        <FileUploader
          multiple={false}
          handleChange={(file) => {
            setProject(prev => ({...prev, file}));
            toast.info("Make sure you have attached the correct file before saving.");
          }}
          name={"file"}
          types={["json"]}
        >
          <Box sx={{
            p: 4, borderRadius: "14px", textAlign: "center", cursor: "pointer",
            bgcolor: "rgba(132, 145, 247, 0.05)", border: "1px dashed rgba(132, 145, 247, 0.35)",
          }}>
            <HugeiconsIcon icon={FileUploadIcon} size={32} color={"#8491F7"}/>
            <Typography sx={{fontWeight: 700, fontSize: 15, color: "#4B55C9", mt: 1}}>
              {project?.file ? "You have attached this file" : "Optional: drag and drop JSON file here"}
            </Typography>
            <Typography sx={{fontSize: 13, color: "#6B6B80", mt: 0.25}}>
              {project?.file ? project.file.name : "or click to upload (50 MB max)"}
            </Typography>
          </Box>
        </FileUploader>

        {project?.file && (
          <Button
            type={"button"}
            onClick={() => setProject(prev => ({...prev, file: null}))}
            sx={{
              mt: 1, textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: "10px",
              color: "#374151", bgcolor: "#FAFAFD", "&:hover": {bgcolor: "#ECECF3"},
            }}
          >
            Remove file
          </Button>
        )}
      </Box>

      <Box sx={{px: {xs: 2, md: 3}, pb: {xs: 2, md: 3}, display: "flex", justifyContent: "flex-end"}}>
        <Button
          data-tour={"create-project-submit"}
          type={"submit"}
          disabled={!project?.name || !project?.language || loading}
          endIcon={loading ? <CircularProgress size={16} sx={{color: "#9CA3AF"}}/> : <HugeiconsIcon icon={ArrowRight01Icon} size={18}/>}
          sx={{
            textTransform: "none", fontWeight: 700, fontSize: 13, borderRadius: "10px", px: 2.5, py: 1.1,
            color: "#fff", bgcolor: "#374151", "&:hover": {bgcolor: "#1F2937"},
            "&.Mui-disabled": {bgcolor: "#D1D5DB", color: "#9CA3AF"},
          }}
        >
          Submit
        </Button>
      </Box>
    </>
  );
};
